export const baseUrl = import.meta.env.VITE_API_URL as string;
export const cardConnectUrl = import.meta.env.VITE_CARDCONNECT_URL as string;
export const loqateApiKey = import.meta.env.VITE_LOQATE_APIKEY as string;
export const lythoCollectionUrl = import.meta.env.VITE_REACT_APP_LYTHO_COLLECTION_URL as string;
export const headerNames: Record<string, string> = {
  '/login': 'PROGRAMS RECOGNITION',
  '/signup': 'PROGRAMS RECOGNITION',
  application: 'APPLICATION',
  '/dashboard': 'DASHBOARD',
  '/statequestions': 'STATE QUESTIONS',
  '/growthaward': 'GROWTH AWARD',
  '/usermanagement': 'USER MANAGEMENT',
  '/pending': 'PENDING',
  '/myaccount': 'ACCOUNT INFO',
};

export const MAX_FILE_SIZE: number = 25 * 1024 * 1024; // 25MB

export enum DatePickerRange {
  AppYear = 1,
  UpToAppYearEnd = 2,
  AcademicAppYear = 3,
  UpToAcademicAppYearEnd = 4,
  All = 5,
}

export enum ApplicationStatus {
  InProgress = 1,
  PendingRegionalReview = 2,
  PendingStateReview = 3,
  InRevision = 4,
  PendingAdfReview = 5,
  ApplicationApproved = 6,
  Closed = 7,
  Denied = 8,
  Submitted = 9,
  PendingNationalReview = 11,
}

export const ApplicationStatusesText: { [key in ApplicationStatus]: string } = {
  [ApplicationStatus.InProgress]: 'In Progress',
  [ApplicationStatus.PendingRegionalReview]: 'Pending Regional Review',
  [ApplicationStatus.PendingStateReview]: 'Pending State Review',
  [ApplicationStatus.InRevision]: 'In Revision',
  [ApplicationStatus.PendingAdfReview]: 'Pending ADF Review',
  [ApplicationStatus.ApplicationApproved]: 'Application Approved',
  [ApplicationStatus.Closed]: 'Closed',
  [ApplicationStatus.Denied]: 'Denied',
  [ApplicationStatus.Submitted]: 'Submitted',
  [ApplicationStatus.PendingNationalReview]: 'Pending National Review',
};

export const treeLineCerficationFeeAmount = 150;
export const treeLineRecertificationFeeAmount = 75;
export const defaultMinDate = '1/1/1753'; // SQL Server min date
export const defaultMaxDate = '12/31/9999'; // SQL Server max date

export const statesLookup = [
  { name: 'Alabama', abbrev: 'AL', id: '01' },
  { name: 'Alaska', abbrev: 'AK', id: '02' },
  { name: 'Arizona', abbrev: 'AZ', id: '04' },
  { name: 'Arkansas', abbrev: 'AR', id: '05' },
  { name: 'California', abbrev: 'CA', id: '06' },
  { name: 'Colorado', abbrev: 'CO', id: '08' },
  { name: 'Connecticut', abbrev: 'CT', id: '09' },
  { name: 'Delaware', abbrev: 'DE', id: '10' },
  { name: 'Florida', abbrev: 'FL', id: '12' },
  { name: 'Georgia', abbrev: 'GA', id: '13' },
  { name: 'Hawaii', abbrev: 'HI', id: '15' },
  { name: 'Idaho', abbrev: 'ID', id: '16' },
  { name: 'Illinois', abbrev: 'IL', id: '17' },
  { name: 'Indiana', abbrev: 'IN', id: '18' },
  { name: 'Iowa', abbrev: 'IA', id: '19' },
  { name: 'Kansas', abbrev: 'KS', id: '20' },
  { name: 'Kentucky', abbrev: 'KY', id: '21' },
  { name: 'Louisiana', abbrev: 'LA', id: '22' },
  { name: 'Maine', abbrev: 'ME', id: '23' },
  { name: 'Maryland', abbrev: 'MD', id: '24' },
  { name: 'Massachusetts', abbrev: 'MA', id: '25' },
  { name: 'Michigan', abbrev: 'MI', id: '26' },
  { name: 'Minnesota', abbrev: 'MN', id: '27' },
  { name: 'Mississippi', abbrev: 'MS', id: '28' },
  { name: 'Missouri', abbrev: 'MO', id: '29' },
  { name: 'Montana', abbrev: 'MT', id: '30' },
  { name: 'Nebraska', abbrev: 'NE', id: '31' },
  { name: 'Nevada', abbrev: 'NV', id: '32' },
  { name: 'New Hampshire', abbrev: 'NH', id: '33' },
  { name: 'New Jersey', abbrev: 'NJ', id: '34' },
  { name: 'New Mexico', abbrev: 'NM', id: '35' },
  { name: 'New York', abbrev: 'NY', id: '36' },
  { name: 'North Carolina', abbrev: 'NC', id: '37' },
  { name: 'North Dakota', abbrev: 'ND', id: '38' },
  { name: 'Ohio', abbrev: 'OH', id: '39' },
  { name: 'Oklahoma', abbrev: 'OK', id: '40' },
  { name: 'Oregon', abbrev: 'OR', id: '41' },
  { name: 'Pennsylvania', abbrev: 'PA', id: '42' },
  { name: 'Rhode Island', abbrev: 'RI', id: '43' },
  { name: 'South Carolina', abbrev: 'SC', id: '44' },
  { name: 'South Dakota', abbrev: 'SD', id: '45' },
  { name: 'Tennessee', abbrev: 'TN', id: '46' },
  { name: 'Texas', abbrev: 'TX', id: '47' },
  { name: 'Utah', abbrev: 'UT', id: '48' },
  { name: 'Vermont', abbrev: 'VT', id: '49' },
  { name: 'Virginia', abbrev: 'VA', id: '50' },
  { name: 'Washington', abbrev: 'WA', id: '51' },
  { name: 'West Virginia', abbrev: 'WV', id: '52' },
  { name: 'Wisconsin', abbrev: 'WI', id: '53' },
  { name: 'Wyoming', abbrev: 'WY', id: '54' },
  { name: 'Overseas Base', abbrev: 'Overseas Base', id: '98' },
];

export const USCountryId = 56;

export function isUrl(URLString: string) {
  try {
    new URL(URLString);
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
}
